import {useFormik} from 'formik';
import * as Yup from 'yup';
import {EditConsentDocumentDTO, useUpdateConsentDocument} from '../../../entities';
import {AxiosError} from 'axios';
import {useSchemes} from '../../../shared';

interface UseEditConsentDocumentFormProps {
  setOpen: (open: boolean) => void;
  documentId: string | null;
}

export const useEditConsentDocumentForm = ({setOpen, documentId}: UseEditConsentDocumentFormProps) => {
  const {getDocument, updateDocumentMutation} = useUpdateConsentDocument(documentId || '');
  const {nameSchema, orderSchema} = useSchemes();

  const onSubmit = async (values: EditConsentDocumentDTO & {isDistinguished: boolean; isMandatory: boolean}) => {
    const {title, displayText, isDistinguished, isMandatory, order} = values;
    try {
      if (documentId) {
        await updateDocumentMutation.mutateAsync({
          documentId,
          title,
          displayText,
          isDistinguished,
          isMandatory,
          order,
        });
      }
      setOpen(false);
    } catch (error: any) {
      console.error(error);
    }
  };

  const formik = useFormik({
    initialValues: {
      title: getDocument.data?.title || '',
      displayText: getDocument.data?.displayText || '',
      isDistinguished: getDocument.data?.isDistinguished || false,
      isMandatory: getDocument.data?.isMandatory || false,
      order: getDocument.data?.order || 0,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: nameSchema,
      displayText: Yup.string().required('Текст для показа обязателен'),
      isDistinguished: Yup.boolean(),
      isMandatory: Yup.boolean(),
      order: orderSchema,
    }),
    onSubmit: onSubmit,
  });

  return {
    values: formik.values,
    errors: formik.errors,
    touched: formik.touched,
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    resetForm: formik.resetForm,
    submitForm: formik.submitForm,
    setFieldValue: formik.setFieldValue,
    isLoading: updateDocumentMutation.isPending || getDocument.isLoading,
    submitError: updateDocumentMutation.error
      ? (updateDocumentMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
  };
};
